// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__k71qN","ellipsis":"styles_ellipsis__XWhez","text2AndMoreLines":"styles_text2AndMoreLines__WRglC","tooltipTrigger":"styles_tooltipTrigger__B2Ekg"};